import React from 'react'
import { INVENTORY_TYPE } from '../../helpers/constants'
import QuoteEditor from './QuoteEditor'

const QuotationView = () => (
  <QuoteEditor inventoryType={INVENTORY_TYPE.typology} />
)

export default QuotationView
